import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import pertoLogo from "../images/perto-logo.png";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { Link } from 'react-router-dom';

export default function Sidebar({ currentRoute, open, menus, currentGroup, setCurrentGroup, toggleBar }) {
  const [openGroups, setOpenGroups] = useState([]);
  const [openMenus, setOpenMenus] = useState([]);

  useEffect(() => {
    let openGroup = {};
    let openMenu = {};
    
    menus.filter(g => g.menusPai.filter(mp => {      
      if(mp.menus.filter(m => checkRouteCurrentRoute(currentRoute, m.rota)).length > 0){
        openGroup = g;
        openMenu = mp;
        return true;
      }
    }));

    if(openGroup.id) {
      setOpenGroups([openGroup.id]);
      setCurrentGroup(openGroup);
    }

    if(openMenu.id) setOpenMenus([openMenu.id]);

  }, [currentRoute, currentGroup]);

  const toggleGroup = (id) => {
    //let openGroupsUpdate = [...openGroups];

    if (openGroups.includes(id)) {
      //openGroupsUpdate = openGroupsUpdate.filter((openId) => openId !== id);
      setOpenGroups([]);
    } else {
      //openGroupsUpdate.push(id);
      setOpenGroups([id]);
    }

    //setOpenGroups([id]);
  };

  const toggleMenu = (id) => {
    if (openMenus.includes(id)) {
      setOpenMenus([]);
    } else {
      setOpenMenus([id]);
    }
  };

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: window.innerWidth < 800 ? mobileWidth : drawerWidth,
          boxSizing: "border-box",
          bgcolor: '#40486e'
        },
        overflow: 'hidden'
      }}
      variant="persistent"
      anchor="left"
      open={open}
      style={{backgroundColor: '#585e78'}}
    >
      <div
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
      >
        <Link to="/app">
        <img
          src={pertoLogo}
          alt=""
          style={{ height: 50, width: 100, marginTop: 10, marginBottom: 5}}
        />
        </Link>
        {/* <span style={{color: 'white', fontWeight: 'bolder', marginBottom: 10}}>Painel Administrativo</span> */}
      </div>
      <Divider/>
      <List
        sx={{ width: "100%", maxWidth: 360, color: 'white', fontWeight: 'bolder' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {menus.map((g, key) => (
          <List
            key={key}
            sx={{ width: "100%", maxWidth: 360 }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            <ListItemButton
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: getGroupColor(g.id),
              }}
              onClick={() => toggleGroup(g.id)}
            >
              <ListItemIcon style={{marginRight: -20, color: 'white'}}>
                <DehazeIcon />
              </ListItemIcon>
              <ListItemText primary={g.nome} />
              {openGroups.includes(g.id) ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            {openGroups.includes(g.id) && g.menusPai.map((m) => (
              <div>
                <ListItemButton onClick={() => toggleMenu(m.id)}>
                  <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                    <div style={{width: '100%', display: 'flex'}}>
                      {m.icone && 
                        <ListItemIcon style={{marginRight: -20}}>
                          <i className={m.icone} style={{color: 'white'}}></i>
                        </ListItemIcon>
                      }
                      <span className="menuLabel1">{m.nome}</span>
                    </div>
                    {openMenus.includes(m.id) ? <ExpandLess /> : <ExpandMore />}
                  </div>
                </ListItemButton>
                <Collapse
                  in={openMenus.includes(m.id)}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {m.menus.map((item) => {
                      return (
                        <Link to={`/app/${item.rota}`} style={menuRouteStyle} onClick={window.innerWidth < 800 ? () => toggleBar() : () => {}}>
                          <ListItemButton
                            // onClick={() => history.push(`/app/${item.rota}`)}
                            // sx={{ pl: 4 }}
                            style={checkRouteCurrentRoute(currentRoute, item.rota) ? {backgroundColor: '#2d48bd'} : {}}
                          >
                            <div className="menuLabel2">{item.nome}</div>
                              {/* <ListItemText primary={item.nome} style={{fontWeight: 'bolder'}} /> */}
                            
                          </ListItemButton>
                          </Link>
                      )
                    })}
                  </List>
                </Collapse>
              </div>
            ))}
          </List>
        ))}
      </List>
    </Drawer>
  );
}

const checkRouteCurrentRoute = (currentRoute, menuRoute) => {
  const source = currentRoute.split('/')[0];

  return (source === menuRoute);
}

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const menuRouteStyle = {
  color: 'white',
  textDecoration: 'none'
}


const drawerWidth = 275;
const mobileWidth = "100%";

const getGroupColor = groupId => {
  switch(groupId){
    case 1: return 'rgba(94, 166, 242, 0.6 )';
    case 2: return 'rgba(128, 255, 225, 0.6 )';
    case 3: return 'rgba(137, 113, 245, 0.6 )';
    case 4: return 'rgba(255, 120, 23, 0.6 )';
    default: return 'green';
  }
}